import { apiRequest } from './client'

interface ApiKeyLocationResponse {
  firm_id: string
  secret_ref: string | null
  migrated: boolean
}

export interface ApiKeyLocation {
  firmId: string
  secretRef: string | null
  migrated: boolean
}

// GET /gui/v1/drafts/current/files/clients/{firm_id}/api-key-location -
// renamed per PRD 21's Locate Client API Key amendment (backend PRD 28,
// Secrets Manager migration): the old .../api-key endpoint that returned a
// firm's real auth.api_key was retired outright, and the client separately
// decided real keys should never reach the frontend at all, migrated or
// not. This endpoint returns only where the key lives - a Secrets Manager
// secret name, or null if the firm hasn't been migrated yet - never a real
// key value. Deliberately its own narrow endpoint rather than the general
// file_key GET surface (draftFiles.ts) - every other read of clients.json
// stays masked exactly per PRD 21 Decision 5; this is only ever called when
// an operator explicitly clicks "Show key location" on one already-saved
// firm.
export async function getFirmApiKeyLocation(firmId: string): Promise<ApiKeyLocation> {
  const result = await apiRequest<ApiKeyLocationResponse>(
    `/gui/v1/drafts/current/files/clients/${firmId}/api-key-location`,
  )
  return { firmId: result.firm_id, secretRef: result.secret_ref, migrated: result.migrated }
}
